import axios from "axios";

export default function UserRegistrationService(formData) {

  return axios({
    method: 'post',
    url: process.env.REACT_APP_API_HOST + "/registration",
    data: formData,
    params: {},
    headers: {}
  });
}
